var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropDownFilter',{attrs:{"menuSections":_vm.dropDownMenuSections,"setLoadingOverlay":_vm.setLoadingOverlay,"storeModule":"GroupCollection"}})
}
var staticRenderFns = []

export { render, staticRenderFns }